// -----------------------------------------------------------------------------
// MySchoolMate — Demo school dataset (Phase 1)
//
// All records are FICTIONAL. `isDemo: true` marks Phase 1 placeholder data.
// This file is intentionally decoupled from UI components so it can later be
// swapped for a real API / database without touching the pages.
// -----------------------------------------------------------------------------

export const CITIES = ["Bandung", "Jakarta", "Tangerang", "Bekasi", "Bogor", "Surabaya"];

export const LEVELS = ["TK", "SD", "SMP", "SMA"];

export const CURRICULA = [
  "Islam Terpadu",
  "Cambridge",
  "Montessori",
  "Nasional+",
  "Nasional",
  "STEM",
  "IB",
];

export const schools = [
  {
    "id": "sch-01",
    "slug": "al-falah-islamic-school",
    "name": "Al-Falah Islamic School",
    "shortDescription": "Sekolah Islam terpadu yang memadukan tahfidz Al-Qur'an dengan program coding dan sains modern.",
    "city": "Bandung",
    "district": "Antapani",
    "distanceKm": 4.2,
    "educationLevels": [
      "TK",
      "SD",
      "SMP"
    ],
    "monthlyTuition": 1800000,
    "entranceFee": 12000000,
    "curriculum": "Islam Terpadu",
    "accreditation": "A",
    "religiousPrograms": [
      "Islam Terpadu",
      "Tahfidz"
    ],
    "studentTeacherRatio": 12,
    "interests": [
      "Coding",
      "Tahfidz",
      "Sains",
      "Olahraga"
    ],
    "tags": [
      "Islam Terpadu",
      "Coding",
      "Tahfidz"
    ],
    "facilities": [
      "Perpustakaan",
      "Lab Komputer",
      "Masjid",
      "Lapangan Olahraga",
      "Kantin Sehat"
    ],
    "extracurriculars": [
      "Coding Club",
      "Tahfidz",
      "Futsal",
      "Robotik",
      "Pramuka"
    ],
    "specialNeedsSupport": false,
    "rating": 4.8,
    "reviewCount": 214,
    "matchScore": 93,
    "image": "https://images.pexels.com/photos/5147366/pexels-photo-5147366.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 10, Antapani, Bandung",
    "about": "Al-Falah Islamic School didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp1.800.000 dengan uang pangkal Rp12.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum Islam Terpadu dengan akreditasi A."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Ya, kami menyediakan program Islam Terpadu, Tahfidz."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Coding Club, Tahfidz, Futsal, Robotik, Pramuka."
      }
    ],
    "images": [
      "https://images.pexels.com/photos/5147366/pexels-photo-5147366.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-02",
    "slug": "cendekia-global-academy",
    "name": "Cendekia Global Academy",
    "shortDescription": "Sekolah kurikulum Cambridge dengan lingkungan berbahasa Inggris dan fokus kepemimpinan global.",
    "city": "Jakarta",
    "district": "Kebayoran Baru",
    "distanceKm": 7,
    "educationLevels": [
      "SD",
      "SMP",
      "SMA"
    ],
    "monthlyTuition": 3500000,
    "entranceFee": 25000000,
    "curriculum": "Cambridge",
    "accreditation": "A",
    "religiousPrograms": [],
    "studentTeacherRatio": 10,
    "interests": [
      "Coding",
      "Bahasa",
      "Sains",
      "Seni"
    ],
    "tags": [
      "Cambridge",
      "Bilingual",
      "Coding"
    ],
    "facilities": [
      "Perpustakaan",
      "Lab Komputer",
      "Lab Sains",
      "Kolam Renang",
      "Auditorium",
      "Lapangan Olahraga"
    ],
    "extracurriculars": [
      "Debate Club",
      "Robotik",
      "Basket",
      "Orkestra",
      "Coding Club"
    ],
    "specialNeedsSupport": false,
    "rating": 4.7,
    "reviewCount": 176,
    "matchScore": 87,
    "image": "https://images.pexels.com/photos/3380736/pexels-photo-3380736.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 11, Kebayoran Baru, Jakarta",
    "about": "Cendekia Global Academy didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp3.500.000 dengan uang pangkal Rp25.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum Cambridge dengan akreditasi A."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Saat ini kami berfokus pada pendidikan karakter secara umum."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Debate Club, Robotik, Basket, Orkestra, Coding Club."
      }
    ],
    "images": [
      "https://images.pexels.com/photos/3380736/pexels-photo-3380736.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-03",
    "slug": "mentari-bangsa-school",
    "name": "Mentari Bangsa School",
    "shortDescription": "Sekolah nasional plus dengan biaya terjangkau, kuat di karakter dan kegiatan olahraga.",
    "city": "Bekasi",
    "district": "Bekasi Selatan",
    "distanceKm": 5,
    "educationLevels": [
      "TK",
      "SD",
      "SMP",
      "SMA"
    ],
    "monthlyTuition": 2100000,
    "entranceFee": 9000000,
    "curriculum": "Nasional+",
    "accreditation": "A",
    "religiousPrograms": [],
    "studentTeacherRatio": 15,
    "interests": [
      "Olahraga",
      "Coding",
      "Seni"
    ],
    "tags": [
      "Nasional+",
      "Olahraga",
      "Coding"
    ],
    "facilities": [
      "Perpustakaan",
      "Lab Komputer",
      "Lapangan Olahraga",
      "Kantin Sehat"
    ],
    "extracurriculars": [
      "Futsal",
      "Basket",
      "Coding Club",
      "Paduan Suara",
      "Pramuka"
    ],
    "specialNeedsSupport": false,
    "rating": 4.6,
    "reviewCount": 143,
    "matchScore": 81,
    "image": "https://images.unsplash.com/photo-1786013522160-00ac876da3ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 12, Bekasi Selatan, Bekasi",
    "phone": "+62 812-3456-7890",
    "email": "info@mentaribangsa.sch.id",
    "website": "https://example.com/mentari-bangsa",
    "contactPerson": {
      "name": "Nadia Putri",
      "role": "Admin Penerimaan Siswa",
      "photo": "/assets/kepala-sekolah.png",
      "whatsapp": "+62 812-3456-7890",
      "responseTime": "Biasanya membalas dalam 15 menit"
    },
    "about": "Mentari Bangsa School didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp2.100.000 dengan uang pangkal Rp9.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum Nasional+ dengan akreditasi A."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Saat ini kami berfokus pada pendidikan karakter secara umum."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Futsal, Basket, Coding Club, Paduan Suara, Pramuka."
      }
    ],
    "images": [
      "https://images.unsplash.com/photo-1786013522160-00ac876da3ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-04",
    "slug": "bina-montessori-academy",
    "name": "Bina Montessori Academy",
    "shortDescription": "Pendekatan Montessori untuk usia dini yang menumbuhkan kemandirian dan rasa ingin tahu anak.",
    "city": "Tangerang",
    "district": "BSD",
    "distanceKm": 9.5,
    "educationLevels": [
      "TK",
      "SD"
    ],
    "monthlyTuition": 2800000,
    "entranceFee": 15000000,
    "curriculum": "Montessori",
    "accreditation": "A",
    "religiousPrograms": [],
    "studentTeacherRatio": 8,
    "interests": [
      "Seni",
      "Sains"
    ],
    "tags": [
      "Montessori",
      "Kelas Kecil",
      "Seni"
    ],
    "facilities": [
      "Perpustakaan",
      "Taman Belajar",
      "Ruang Seni",
      "Kantin Sehat"
    ],
    "extracurriculars": [
      "Melukis",
      "Berkebun",
      "Musik",
      "Tari Tradisional"
    ],
    "specialNeedsSupport": true,
    "rating": 4.9,
    "reviewCount": 98,
    "matchScore": 84,
    "image": "https://images.unsplash.com/photo-1527822618093-743f3e57977c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 13, BSD, Tangerang",
    "about": "Bina Montessori Academy didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp2.800.000 dengan uang pangkal Rp15.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum Montessori dengan akreditasi A."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Saat ini kami berfokus pada pendidikan karakter secara umum."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Melukis, Berkebun, Musik, Tari Tradisional."
      },
      {
        "question": "Apakah sekolah mendukung kebutuhan khusus?",
        "answer": "Ya, kami memiliki program pendidikan inklusif dengan guru pendamping khusus (shadow teacher) dan ruang terapi."
      }
    ],
    "images": [
      "https://images.unsplash.com/photo-1527822618093-743f3e57977c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-05",
    "slug": "harapan-inclusive-school",
    "name": "Harapan Inclusive School",
    "shortDescription": "Sekolah inklusif dengan dukungan penuh untuk anak berkebutuhan khusus dan kelas berukuran kecil.",
    "city": "Bandung",
    "district": "Cimahi",
    "distanceKm": 6.3,
    "educationLevels": [
      "TK",
      "SD",
      "SMP"
    ],
    "monthlyTuition": 2400000,
    "entranceFee": 8000000,
    "curriculum": "Nasional",
    "accreditation": "B",
    "religiousPrograms": [],
    "studentTeacherRatio": 9,
    "interests": [
      "Seni",
      "Olahraga"
    ],
    "tags": [
      "Inklusif",
      "Kelas Kecil",
      "Seni"
    ],
    "facilities": [
      "Perpustakaan",
      "Ruang Terapi",
      "Ruang Seni",
      "Lapangan Olahraga",
      "Taman Belajar"
    ],
    "extracurriculars": [
      "Melukis",
      "Musik",
      "Renang Adaptif",
      "Pramuka"
    ],
    "specialNeedsSupport": true,
    "rating": 4.8,
    "reviewCount": 121,
    "matchScore": 79,
    "image": "https://images.pexels.com/photos/8618068/pexels-photo-8618068.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 14, Cimahi, Bandung",
    "about": "Harapan Inclusive School didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp2.400.000 dengan uang pangkal Rp8.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum Nasional dengan akreditasi B."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Saat ini kami berfokus pada pendidikan karakter secara umum."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Melukis, Musik, Renang Adaptif, Pramuka."
      },
      {
        "question": "Apakah sekolah mendukung kebutuhan khusus?",
        "answer": "Ya, kami memiliki program pendidikan inklusif dengan guru pendamping khusus (shadow teacher) dan ruang terapi."
      }
    ],
    "images": [
      "https://images.pexels.com/photos/8618068/pexels-photo-8618068.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-06",
    "slug": "pelita-nusantara-school",
    "name": "Pelita Nusantara School",
    "shortDescription": "Sekolah nasional dengan biaya ramah keluarga dan pembinaan karakter kebangsaan yang kuat.",
    "city": "Bogor",
    "district": "Bogor Utara",
    "distanceKm": 11,
    "educationLevels": [
      "SD",
      "SMP",
      "SMA"
    ],
    "monthlyTuition": 1500000,
    "entranceFee": 6000000,
    "curriculum": "Nasional",
    "accreditation": "A",
    "religiousPrograms": [],
    "studentTeacherRatio": 18,
    "interests": [
      "Olahraga",
      "Seni"
    ],
    "tags": [
      "Nasional",
      "Terjangkau",
      "Olahraga"
    ],
    "facilities": [
      "Perpustakaan",
      "Lapangan Olahraga",
      "Kantin Sehat",
      "Lab Komputer"
    ],
    "extracurriculars": [
      "Sepak Bola",
      "Pramuka",
      "Paduan Suara",
      "Karawitan"
    ],
    "specialNeedsSupport": false,
    "rating": 4.4,
    "reviewCount": 87,
    "matchScore": 74,
    "image": "https://images.unsplash.com/photo-1574130303188-31a915382726?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 15, Bogor Utara, Bogor",
    "about": "Pelita Nusantara School didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp1.500.000 dengan uang pangkal Rp6.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum Nasional dengan akreditasi A."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Saat ini kami berfokus pada pendidikan karakter secara umum."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Sepak Bola, Pramuka, Paduan Suara, Karawitan."
      }
    ],
    "images": [
      "https://images.unsplash.com/photo-1574130303188-31a915382726?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-07",
    "slug": "bandung-creative-school",
    "name": "Bandung Creative School",
    "shortDescription": "Sekolah yang berfokus pada kreativitas, seni, dan desain dengan studio dan makerspace.",
    "city": "Bandung",
    "district": "Dago",
    "distanceKm": 3.1,
    "educationLevels": [
      "SMP",
      "SMA"
    ],
    "monthlyTuition": 3200000,
    "entranceFee": 18000000,
    "curriculum": "Nasional+",
    "accreditation": "A",
    "religiousPrograms": [],
    "studentTeacherRatio": 11,
    "interests": [
      "Seni",
      "Coding"
    ],
    "tags": [
      "Kreatif",
      "Seni",
      "Makerspace"
    ],
    "facilities": [
      "Studio Seni",
      "Makerspace",
      "Lab Komputer",
      "Perpustakaan",
      "Auditorium"
    ],
    "extracurriculars": [
      "Film & Fotografi",
      "Desain Grafis",
      "Coding Club",
      "Band"
    ],
    "specialNeedsSupport": false,
    "rating": 4.7,
    "reviewCount": 132,
    "matchScore": 82,
    "image": "https://images.unsplash.com/photo-1774268977695-e7cedbb5f752?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 16, Dago, Bandung",
    "about": "Bandung Creative School didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp3.200.000 dengan uang pangkal Rp18.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum Nasional+ dengan akreditasi A."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Saat ini kami berfokus pada pendidikan karakter secara umum."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Film & Fotografi, Desain Grafis, Coding Club, Band."
      }
    ],
    "images": [
      "https://images.unsplash.com/photo-1774268977695-e7cedbb5f752?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-08",
    "slug": "cakrawala-international-academy",
    "name": "Cakrawala International Academy",
    "shortDescription": "Sekolah internasional kurikulum IB dengan komunitas beragam dan fasilitas lengkap.",
    "city": "Jakarta",
    "district": "Pondok Indah",
    "distanceKm": 8.7,
    "educationLevels": [
      "TK",
      "SD",
      "SMP",
      "SMA"
    ],
    "monthlyTuition": 5200000,
    "entranceFee": 40000000,
    "curriculum": "IB",
    "accreditation": "A",
    "religiousPrograms": [],
    "studentTeacherRatio": 9,
    "interests": [
      "Coding",
      "Bahasa",
      "Sains",
      "Olahraga"
    ],
    "tags": [
      "IB",
      "Internasional",
      "Bilingual"
    ],
    "facilities": [
      "Perpustakaan",
      "Lab Sains",
      "Lab Komputer",
      "Kolam Renang",
      "Auditorium",
      "Lapangan Olahraga",
      "Studio Seni"
    ],
    "extracurriculars": [
      "Robotik",
      "Renang",
      "Debate Club",
      "Orkestra",
      "Basket"
    ],
    "specialNeedsSupport": true,
    "rating": 4.8,
    "reviewCount": 205,
    "matchScore": 80,
    "image": "https://images.pexels.com/photos/8926848/pexels-photo-8926848.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 17, Pondok Indah, Jakarta",
    "about": "Cakrawala International Academy didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp5.200.000 dengan uang pangkal Rp40.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum IB dengan akreditasi A."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Saat ini kami berfokus pada pendidikan karakter secara umum."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Robotik, Renang, Debate Club, Orkestra, Basket."
      },
      {
        "question": "Apakah sekolah mendukung kebutuhan khusus?",
        "answer": "Ya, kami memiliki program pendidikan inklusif dengan guru pendamping khusus (shadow teacher) dan ruang terapi."
      }
    ],
    "images": [
      "https://images.pexels.com/photos/8926848/pexels-photo-8926848.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-09",
    "slug": "bintang-insani-school",
    "name": "Bintang Insani School",
    "shortDescription": "Sekolah Islam terpadu dengan program tahfidz intensif dan pembinaan akhlak sehari-hari.",
    "city": "Bekasi",
    "district": "Harapan Indah",
    "distanceKm": 6.8,
    "educationLevels": [
      "TK",
      "SD",
      "SMP"
    ],
    "monthlyTuition": 1650000,
    "entranceFee": 7500000,
    "curriculum": "Islam Terpadu",
    "accreditation": "A",
    "religiousPrograms": [
      "Islam Terpadu",
      "Tahfidz"
    ],
    "studentTeacherRatio": 14,
    "interests": [
      "Tahfidz",
      "Olahraga"
    ],
    "tags": [
      "Islam Terpadu",
      "Tahfidz",
      "Terjangkau"
    ],
    "facilities": [
      "Masjid",
      "Perpustakaan",
      "Lapangan Olahraga",
      "Lab Komputer",
      "Kantin Sehat"
    ],
    "extracurriculars": [
      "Tahfidz",
      "Panahan",
      "Futsal",
      "Kaligrafi",
      "Pramuka"
    ],
    "specialNeedsSupport": false,
    "rating": 4.6,
    "reviewCount": 109,
    "matchScore": 85,
    "image": "https://images.unsplash.com/photo-1577896851231-70ef18881754?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 18, Harapan Indah, Bekasi",
    "about": "Bintang Insani School didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp1.650.000 dengan uang pangkal Rp7.500.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum Islam Terpadu dengan akreditasi A."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Ya, kami menyediakan program Islam Terpadu, Tahfidz."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Tahfidz, Panahan, Futsal, Kaligrafi, Pramuka."
      }
    ],
    "images": [
      "https://images.unsplash.com/photo-1577896851231-70ef18881754?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-10",
    "slug": "tunas-bangsa-academy",
    "name": "Tunas Bangsa Academy",
    "shortDescription": "Sekolah nasional plus yang seimbang antara akademik, olahraga, dan pengembangan bakat.",
    "city": "Tangerang",
    "district": "Gading Serpong",
    "distanceKm": 10.2,
    "educationLevels": [
      "SD",
      "SMP",
      "SMA"
    ],
    "monthlyTuition": 2600000,
    "entranceFee": 11000000,
    "curriculum": "Nasional+",
    "accreditation": "A",
    "religiousPrograms": [],
    "studentTeacherRatio": 13,
    "interests": [
      "Olahraga",
      "Coding",
      "Bahasa"
    ],
    "tags": [
      "Nasional+",
      "Olahraga",
      "Bahasa"
    ],
    "facilities": [
      "Perpustakaan",
      "Lab Komputer",
      "Kolam Renang",
      "Lapangan Olahraga",
      "Kantin Sehat"
    ],
    "extracurriculars": [
      "Renang",
      "Basket",
      "English Club",
      "Coding Club",
      "Taekwondo"
    ],
    "specialNeedsSupport": false,
    "rating": 4.5,
    "reviewCount": 96,
    "matchScore": 78,
    "image": "https://images.unsplash.com/photo-1561089489-f13d5e730d72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 19, Gading Serpong, Tangerang",
    "about": "Tunas Bangsa Academy didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp2.600.000 dengan uang pangkal Rp11.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum Nasional+ dengan akreditasi A."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Saat ini kami berfokus pada pendidikan karakter secara umum."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Renang, Basket, English Club, Coding Club, Taekwondo."
      }
    ],
    "images": [
      "https://images.unsplash.com/photo-1561089489-f13d5e730d72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-11",
    "slug": "nusantara-stem-school",
    "name": "Nusantara STEM School",
    "shortDescription": "Sekolah berbasis STEM dengan laboratorium modern, robotik, dan proyek sains terapan.",
    "city": "Surabaya",
    "district": "Gubeng",
    "distanceKm": 5.9,
    "educationLevels": [
      "SMP",
      "SMA"
    ],
    "monthlyTuition": 2900000,
    "entranceFee": 14000000,
    "curriculum": "STEM",
    "accreditation": "A",
    "religiousPrograms": [],
    "studentTeacherRatio": 12,
    "interests": [
      "Coding",
      "Sains"
    ],
    "tags": [
      "STEM",
      "Coding",
      "Robotik"
    ],
    "facilities": [
      "Lab Sains",
      "Lab Komputer",
      "Makerspace",
      "Perpustakaan",
      "Lapangan Olahraga"
    ],
    "extracurriculars": [
      "Robotik",
      "Coding Club",
      "Olimpiade Sains",
      "Astronomi"
    ],
    "specialNeedsSupport": false,
    "rating": 4.7,
    "reviewCount": 118,
    "matchScore": 83,
    "image": "https://images.unsplash.com/photo-1758611228434-7b5b697abd0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 20, Gubeng, Surabaya",
    "about": "Nusantara STEM School didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp2.900.000 dengan uang pangkal Rp14.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum STEM dengan akreditasi A."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Saat ini kami berfokus pada pendidikan karakter secara umum."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Robotik, Coding Club, Olimpiade Sains, Astronomi."
      }
    ],
    "images": [
      "https://images.unsplash.com/photo-1758611228434-7b5b697abd0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  },
  {
    "id": "sch-12",
    "slug": "cahaya-mandiri-school",
    "name": "Cahaya Mandiri School",
    "shortDescription": "Sekolah nasional yang hangat dan terjangkau dengan pembinaan kemandirian dan kewirausahaan.",
    "city": "Bogor",
    "district": "Cibinong",
    "distanceKm": 12.4,
    "educationLevels": [
      "TK",
      "SD",
      "SMP"
    ],
    "monthlyTuition": 1400000,
    "entranceFee": 5000000,
    "curriculum": "Nasional",
    "accreditation": "B",
    "religiousPrograms": [],
    "studentTeacherRatio": 17,
    "interests": [
      "Seni",
      "Olahraga"
    ],
    "tags": [
      "Nasional",
      "Terjangkau",
      "Kewirausahaan"
    ],
    "facilities": [
      "Perpustakaan",
      "Lapangan Olahraga",
      "Kantin Sehat",
      "Kebun Sekolah"
    ],
    "extracurriculars": [
      "Kewirausahaan",
      "Sepak Bola",
      "Seni Tari",
      "Pramuka"
    ],
    "specialNeedsSupport": false,
    "rating": 4.3,
    "reviewCount": 64,
    "matchScore": 72,
    "image": "https://images.unsplash.com/photo-1786294111520-879ab6639891?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "isDemo": true,
    "address": "Jl. Pendidikan No. 21, Cibinong, Bogor",
    "about": "Cahaya Mandiri School didirikan untuk menjawab kebutuhan masyarakat akan pendidikan berkualitas. Kami berkomitmen untuk menciptakan lingkungan belajar yang aman, inklusif, dan inspiratif. Dengan fasilitas modern dan tenaga pendidik berpengalaman, kami berusaha mencetak generasi penerus yang cerdas dan berkarakter.",
    "faq": [
      {
        "question": "Berapa kisaran biaya sekolah?",
        "answer": "Biaya bulanan adalah sekitar Rp1.400.000 dengan uang pangkal Rp5.000.000."
      },
      {
        "question": "Kurikulum apa yang digunakan?",
        "answer": "Sekolah kami menggunakan kurikulum Nasional dengan akreditasi B."
      },
      {
        "question": "Apakah tersedia program keagamaan?",
        "answer": "Saat ini kami berfokus pada pendidikan karakter secara umum."
      },
      {
        "question": "Kegiatan ekstrakurikuler apa yang tersedia?",
        "answer": "Kami memiliki berbagai kegiatan seperti Kewirausahaan, Sepak Bola, Seni Tari, Pramuka."
      }
    ],
    "images": [
      "https://images.unsplash.com/photo-1786294111520-879ab6639891?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
    ]
  }
];

export function getSchoolBySlug(slug) {
  return schools.find((s) => s.slug === slug);
}
